import {
  LOAD_DELIVERY_TIMES,
  LOAD_BROKERS,
  LOAD_PRODUCTS,
  SET_OFFER_DEPOSIT,
  SET_OFFER_DISTANCE,
  SET_OFFER_DURATION,
  SET_OFFER_NOTES,
  SET_OFFER_PRIVATE_NOTES,
  SET_OFFER_REFERENCE,
  SET_OFFER_RIGHT_LABEL,
  SET_OFFER_MONTHLY_RATE,
  SET_OFFER_FAST_DELIVERY,
  SET_OFFER_DELIVERY_TIME,
  SET_OFFER_DELIVERY_TIMES,
  SET_OFFER_BROKER,
  SET_OFFER_BROKERS,
  SET_OFFER_PRODUCT,
  SET_OFFER_PRODUCTS,
  VALIDATE_USER_INPUT,
  SET_ERROR_MESSAGE,
  RESET,
} from './constants';

/**
 *
 */
export function loadDeliveryTimes() {
  return {
    type: LOAD_DELIVERY_TIMES,
  };
}

/**
 *
 */
export function loadBrokers() {
  return {
    type: LOAD_BROKERS,
  };
}

export function loadProducts() {
  return {
    type: LOAD_PRODUCTS,
  };
}

/**
 *
 * @param monthlyRate
 * @returns {{price: *, type: *}}
 */
export function setMonthlyRate(monthlyRate) {
  return {
    type: SET_OFFER_MONTHLY_RATE,
    monthlyRate,
  };
}

/**
 *
 * @param duration
 * @returns {{duration: *, type: *}}
 */
export function setDuration(duration) {
  return {
    type: SET_OFFER_DURATION,
    duration,
  };
}

/**
 *
 * @param key
 * @param label
 */
export function setRightLabel(key, label) {
  return {
    type: SET_OFFER_RIGHT_LABEL,
    key,
    label,
  };
}

/**
 *
 * @param distance
 * @returns {{distance: *, type: *}}
 */
export function setDistance(distance) {
  return {
    type: SET_OFFER_DISTANCE,
    distance,
  };
}

/**
 *
 * @param notes
 * @returns {{notes: *, type: *}}
 */
export function setNotes(notes) {
  return {
    type: SET_OFFER_NOTES,
    notes,
  };
}

/**
 *
 * @param private_notes
 * @returns {{notes: *, type: *}}
 */
export function setPrivateNotes(private_notes) {
  return {
    type: SET_OFFER_PRIVATE_NOTES,
    private_notes,
  };
}

/**
 *
 * @param reference
 * @returns {{reference: *, type: *}}
 */
export function setReference(reference) {
  return {
    type: SET_OFFER_REFERENCE,
    reference,
  };
}

/**
 *
 * @param fastDelivery
 * @returns {{fastDelivery: *, type: *}}
 */
export function setFastDelivery(fastDelivery) {
  return {
    type: SET_OFFER_FAST_DELIVERY,
    fastDelivery,
  };
}

/**
 *
 * @param deliveryTime
 * @returns {{deliveryTime: *, type: *}}
 */
export function setDeliveryTime(deliveryTime) {
  return {
    type: SET_OFFER_DELIVERY_TIME,
    deliveryTime,
  };
}

/**
 *
 * @param deliveryTimes
 * @returns {{deliveryTimes: *, type: *}}
 */
export function setDeliveryTimes(deliveryTimes) {
  return {
    type: SET_OFFER_DELIVERY_TIMES,
    deliveryTimes,
  };
}

/**
 *
 * @param broker
 * @returns {{broker: *, type: *}}
 */
export function setBroker(broker) {
  return {
    type: SET_OFFER_BROKER,
    broker,
  };
}

/**
 *
 * @param brokers
 * @returns {{brokers: *, type: *}}
 */
export function setBrokers(brokers) {
  return {
    type: SET_OFFER_BROKERS,
    brokers,
  };
}

/**
 *
 * @param product
 * @returns {{product: *, type: *}}
 */
export function setProduct(product) {
  return {
    type: SET_OFFER_PRODUCT,
    product,
  };
}

/**
 *
 * @param products
 * @returns {{products: *, type: *}}
 */
export function setProducts(products) {
  return {
    type: SET_OFFER_PRODUCTS,
    products,
  };
}

/**
 *
 * @param deposit
 * @returns {{deposit: *, type: *}}
 */
export function setDeposit(deposit) {
  return {
    type: SET_OFFER_DEPOSIT,
    deposit,
  };
}

/**
 *
 * @param hasError
 * @returns {{hasError: *, type: *}}
 */
export function hasError(hasError) {
  return {
    type: VALIDATE_USER_INPUT,
    hasError,
  };
}


/**
 *
 * @param msg
 * @returns {{msg: *, type: *}}
 */
export function setErrorMsg(msg) {
  return {
    type: SET_ERROR_MESSAGE,
    msg,
  };
}

/**
 *
 * @returns {{type: *}}
 */
export function resetStore() {
  return {
    type: RESET,
  };
}
